<template>
  <div>
    <page-header :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <div
            v-if="isCaseReported"
            class="card invoice-details"
            style="border: 1px solid #404656"
          >
            <div
              class="card-header d-flex align-items-center justify-content-start gap-2"
            >
              <h3>{{ $t("connectedCase") }}</h3>
              <div class="">
                <p class="status-tag" v-if="reportCaseID.status">
                  {{ reportCaseID.status }}
                </p>
              </div>
            </div>
            <div class="card-body px-3">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-12">
                  <div
                    class="d-flex align-items-center justify-content-between"
                    style="margin-bottom: 8px"
                  >
                    <h5>{{ $t("caseName") }}</h5>
                    <p v-if="reportCaseID.name">
                      {{ reportCaseID.name }}
                    </p>
                    <p v-else>-</p>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h5>{{ $t("caseStatus") }}</h5>

                    <p
                      class="status-tag text-center"
                      v-if="reportCaseID.caseStatus"
                    >
                      {{ reportCaseID.caseStatus }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-row>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group">
                <ElLabel
                  class="form-label"
                  for-label="title"
                  :title="$t('title')"
                  :is-required-icon="true"
                />
                <validation-provider
                  #default="{ errors }"
                  name="Title"
                  rules="required"
                >
                  <input
                    id="title"
                    v-model="form.title"
                    name="title"
                    class="form-control"
                    :disabled="btnLoading"
                    type="text"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group">
                <ElLabel
                  class="form-label"
                  for-label="priorty"
                  :title="$t('priority')"
                  :is-required-icon="true"
                />
                <validation-provider
                  #default="{ errors }"
                  name="Priority"
                  rules="required"
                >
                  <select
                    class="form-control"
                    v-model="form.priority"
                    :disabled="btnLoading"
                    :class="{ 'is-invalid': errors[0] }"
                  >
                    <option value="low">{{ $t("low") }}</option>
                    <option value="normal">{{ $t("normal") }}</option>
                    <option value="high">{{ $t("high") }}</option>
                  </select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group">
                <ElLabel
                  class="form-label"
                  for-label="status"
                  :title="$t('status')"
                  :is-required-icon="true"
                />
                <validation-provider
                  #default="{ errors }"
                  name="Status"
                  rules="required"
                >
                  <select
                    class="form-control"
                    v-model="form.status"
                    :disabled="btnLoading"
                    :class="{ 'is-invalid': errors[0] }"
                  >
                    <option value="new">
                      {{ $t("new") }}
                    </option>
                    <option value="open">
                      {{ $t("open") }}
                    </option>
                    <option value="waiting-for-response">
                      {{ $t("waitingForResponse") }}
                    </option>
                    <option value="pending">
                      {{ $t("pending") }}
                    </option>
                    <option value="resolved">
                      {{ $t("resolved") }}
                    </option>
                  </select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("company")
                }}</label>
                <MultiSelectInput
                  :class="'multiselect-zindex'"
                  v-model="form.companyId"
                  :options="customers"
                  :query="{ isMultiSelect: true }"
                  label="companyName"
                  trackBy="id"
                  :key="form.companyId"
                  moduleName="customers"
                  :multiple="false"
                  ><template #option="{ props }">
                    <div>
                      <p>
                        {{ props.option.companyNumber }} -
                        {{ props.option.companyName }}
                      </p>
                    </div>
                  </template>
                </MultiSelectInput>
              </div>
            </b-col>
            <b-col cols="12" class="mb-1">
              <div class="form-group">
                <label class="form-label"
                  >{{ $t("text")
                  }}<span style="color: red">&nbsp;*</span></label
                >
                  <MarkdownEditor
                    :content="form.text || ''"
                    @change="form.text = $event"
                    :builder-images="[]"
                    :editable="true"
                    @imageAdded="addCommentImages"
                  />
              </div>
            </b-col>

            <b-col cols="12" class="mb-1">
              <div class="dropzone">
                <vue-dropzone
                  id="dropzone"
                  ref="myDropzone"
                  :options="dropzoneOptions"
                />
              </div>
              <showFiles
                :commentFiles="attachments"
                :showImages="true"
                @remove="deleteUpload"
              />
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-2 gap-2">
        <router-link
          to="/tickets"
          class="d-flex align-items-center gap-1 btn btn-secondary"
        >
          <feather-icon icon="XIcon" size="12" />
          <span>{{ $t("cancel") }}</span>
        </router-link>
        <loading-button
          v-if="$can(`${$route.meta.permission}.create`)"
          @click="submit"
          :loading="btnLoading"
          :disabled="isFormInvalid"
        >
          <feather-icon class="" icon="PlusIcon" size="12" />
          <span>{{ $t("create") + " " + $t("ticket") }}</span>
        </loading-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vueDropzone from "vue2-dropzone";
import ElLabel from "@/components/ElLabel.vue";
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import showFiles from "@/components/ticketSystem/show-files.vue";
import MarkdownEditor from "@/components/MarkdownEditor.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import usersStoreMixin from "@/mixins/usersStoreMixin";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";
import formDirtyMixin from "@/mixins/formDirtyMixin";

export default {
  mixins: [usersStoreMixin, fileHandlerMixin, formDirtyMixin],
  components: {
    vueDropzone: vueDropzone,
    showFiles,
    ElLabel,
    TextInput,
    PageHeader,
    MultiSelectInput,
    MarkdownEditor,
    LoadingButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      ticketCreationForms: [],
      areaList: [
        {
          id: "partner",
          name: "Partner",
        },
        {
          id: "customer",
          name: "Company",
        },
        {
          id: "product",
          name: "Product",
        },
      ],
      form: {
        title: "",
        status: "new",
        priority: "normal",
        companyId: "",
        text: "",
        images: [],
      },
      attachments: [],
      originalForm: null,
      pendingFiles: [],
      submitted: false,
      btnLoading: false,
      isLoading: false,
      isCaseReported: false,
    };
  },
  computed: {
    ...mapGetters("tickets", ["tickets"]),
    ...mapGetters("users", ["userProfiles"]),
    ...mapGetters(["showLoader"]),
    ...mapGetters("caseLists", ["reportCaseID"]),
    ...mapGetters("customers", ["customers"]),
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/",
        },
        {
          text: this.$t("Tickets"),
          to: "/tickets",
        },
        {
          text: this.$t("create"),
          active: true,
        },
      ];
    },
    dropzoneOptions() {
      const component = this; // Capture the component context
      return {
        url: process.env.backEndUrl + "/api/convert-file-to-base64",
        autoProcessQueue: false,
        maxFiles: 5,
        accept: function (file, done) {
          done();
        },
        acceptedFiles:
          ".jpg,.jpeg,.png,.pdf,.csv,.doc,.docx,.ppt,.pptx,.xls,.xlsx",
        dictDefaultMessage: `<i class='fe-upload-cloud'></i>${this.$t(
          "clickOrDragFile"
        )}`,
        addRemoveLinks: true,
        init: function () {
          this.on("addedfile", function (file) {
            component.processFile(file); // Use the component context
          });
        },
      };
    },
    isFormInvalid() {
      return (
        !this.form.title ||
        !this.form.priority ||
        !this.form.status ||
        !this.form.text ||
        this.form.text.length < 40
      );
    },
  },
  beforeDestroy() {
    this.$store.commit("caseLists/reportCaseID", null);
  },
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  async mounted() {
    this.updateDropzoneMessage(); // Set initial message
    this.$watch("$i18n.locale", () => {
      this.updateDropzoneMessage(); // Update message when language changes
    });
    this.$store.commit("showLoader", true);
    if (this.reportCaseID) {
      this.isCaseReported = true;
      this.form.title = "Reported Case - " + this.reportCaseID.name;
    }
    this.$store.commit("showLoader", false);
    this.originalForm = JSON.stringify(this.form);

    await this.$store.dispatch("customers/list", { isMultiSelect: true });
  },
  methods: {
    updateDropzoneMessage() {
      if (this.$refs.myDropzone && this.$refs.myDropzone.dropzone) {
        const dropzoneInstance = this.$refs.myDropzone.dropzone;
        dropzoneInstance.options.dictDefaultMessage =
          this.$t("clickOrDragFile");
        dropzoneInstance.element.querySelector(".dz-message").textContent =
          this.$t("clickOrDragFile");
      }
    },
    addCommentImages(event) {
      this.form.images = event;
    },
    customLabel(props) {
      return `${props?.first_name || ""} ${props?.last_name || ""}`;
    },
    deleteUpload(index) {
      this.attachments.splice(index, 1);
    },
    processFile(file) {
      const fileData = {
        file: file,
        name: file.name,
        type: file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase(),
        size: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
      };
      this.pendingFiles.push(fileData);
      this.attachments.push(fileData);
      this.$refs.myDropzone.removeAllFiles();
    },
    base64ToFile(base64String, filename) {
      // Split the base64 string to get the content type and the actual data
      const arr = base64String.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    async submit() {
      this.btnLoading = true;
      this.submitted = true;
      try {
        this.$refs.simpleRules.validate().then(async (success) => {
          if (success) {
            this.$store.commit("showLoader", true);
            let hasUploadError = false;
            // Upload all pending files
            const uploadedFiles = [];
            for (const fileData of this.pendingFiles) {
              try {
                const response = await this.handleFileUpload(fileData.file);
                if (!response?.data[0]?.id) {
                  hasUploadError = true;
                  break;
                }
                uploadedFiles.push({
                  id: response?.data[0]?.id,
                  name: fileData.name,
                  extension: fileData.type,
                  size: fileData.size,
                });
              } catch (error) {
                console.error("Error uploading file:", error);
                hasUploadError = true;
                break;
              }
            }

            // Upload markdown images if any
            let uploadedImages = [];
            if (
              !hasUploadError &&
              this.form.images &&
              this.form.images.length > 0
            ) {
              for (const image of this.form.images) {
                try {
                  // Convert base64 to File object
                  const file = this.base64ToFile(image.base64, image.name);
                  const response = await this.handleFileUpload(file);
                  if (!response?.data[0]?.id) {
                    hasUploadError = true;
                    break;
                  }
                  uploadedImages.push({
                    id: response?.data[0]?.id,
                    name: image.name,
                    rects: image.rects,
                    position: image.position,
                    extension: response?.data[0]?.type,
                  });
                } catch (error) {
                  console.error("Error uploading markdown image:", error);
                  hasUploadError = true;
                  break;
                }
              }
            }

            if (hasUploadError) {
              this.$toast.error(
                this.$t("errorUploadingFilesPleaseTryAgain")
              );
              this.btnLoading = false;
              return;
            }

            await this.$store
              .dispatch("tickets/create", {
                ...this.form,
                companyId: this.form.companyId?.id ?? null,
                attachments: uploadedFiles,
                images: uploadedImages,
                visibility: "public",
                ...(this.isCaseReported
                  ? { caseId: this.reportCaseID.id }
                  : {}),
              })
              .then(async (response) => {
                this.$store.commit("showLoader", false);
                this.isFormDirty = false;
                this.originalForm = JSON.stringify(this.form);
                this.$router.push("/tickets");
              });
          }
        });
      } catch (e) {
        console.log(e);
        this.$toast.error(this.$t("anErrorOccurredPleaseTryAgain"));
      } finally {
        this.btnLoading = false;
      }
    },
  },
};
</script>

<style scoped>
li .v-md-editor__tooltip {
  display: none !important;
}
.hidden {
  display: none !important;
}
.tooltip-hidden {
  display: none !important;
}
:deep(.markdown-body) {
  height: 350px;
  background-color: transparent !important;
}
:deep(.dropzone) .dz-preview {
  z-index: 1 !important;
}
</style>
<style lang="scss">
.multiselect-zindex {
  .multiselect {
    z-index: 500 !important;
  }
}
</style>
